import React, { useState, useEffect } from "react"

import { withAppSettingsConfig } from "./AppSettingsConfigProvider"
import { API_STATUS } from "../shared_components/widgets/utils"
import { getObjectsList } from "../Loaders"
import { logToServer } from "../ErrorBoundary"

export const InventoryConfigContext = React.createContext({})

export function withInventoryConfig(Component) {
  return function (props) {
    return (
      <InventoryConfigContext.Consumer>
        {(configData) => <Component {...props} {...configData} />}
      </InventoryConfigContext.Consumer>
    )
  }
}

function InventoryConfigProvider(props) {
  const [user_permissions, setUserPermissions] = useState([])
  const [reqInvTypes, setReqInvTypes] = useState([])
  useEffect(() => {
    if (props.config && props.config.user) {
      setUserPermissions(props.config.user.permissions)
      setReqInvTypes(props.config?.settings?.required_inventory_types || [])
    }
  }, [props?.config?.user, props.config?.settings])

  const [statusInvtTypes, setStatusInvtTypes] = useState(null)
  const [listInventoryTypes, setListInventoryTypes] = useState([])
  const getInventoryTypes = () => {
    setStatusInvtTypes(API_STATUS.LOADING)
    setListInventoryTypes([])
    getObjectsList("/laboratory/inventory/inventory-type/")
      .then((t) => {
        setStatusInvtTypes(API_STATUS.SUCCESS)
        setListInventoryTypes(t)
      })
      .catch((error) => {
        logToServer(error)
        console.error(error)
        setStatusInvtTypes(API_STATUS.ERROR)
      })
  }

  const [statusInvtItems, setStatusInvtItems] = useState(null)
  const [listInventoryItems, setListInventoryItems] = useState([])
  const getInventoryItems = () => {
    setStatusInvtItems(API_STATUS.LOADING)
    setListInventoryItems([])
    getObjectsList("/laboratory/inventory/inventory-item/")
      .then((t) => {
        setStatusInvtItems(API_STATUS.SUCCESS)
        setListInventoryItems(t)
      })
      .catch((error) => {
        logToServer(error)
        console.error(error)
        setStatusInvtItems(API_STATUS.ERROR)
      })
  }

  const [statusProcItems, setStatusProcItems] = useState(null)
  const [listProcurementItems, setListProcurementItems] = useState([])
  const getProcurementItems = () => {
    setStatusProcItems(API_STATUS.LOADING)
    setListProcurementItems([])
    getObjectsList("/laboratory/inventory/procurement-item/?status__ne=received")
      .then((t) => {
        setStatusProcItems(API_STATUS.SUCCESS)
        setListProcurementItems(t)
      })
      .catch((error) => {
        logToServer(error)
        console.error(error)
        setStatusProcItems(API_STATUS.ERROR)
      })
  }

  useEffect(() => {
    getInventoryTypes()
    getInventoryItems()
    getProcurementItems()
  }, [])

  const [tempInvTypes, setTempInvTypes] = useState([])
  useEffect(() => {
    const usedInvTypes = [
      ...new Set(
        [
          ...reqInvTypes,
          ...listInventoryItems.map((i) => i?.sku?.inventory_type?.name),
          ...listProcurementItems.map((i) => i?.inventory_type?.name),
        ].filter((i) => i),
      ),
    ]
    setTempInvTypes(listInventoryTypes.filter((t) => !usedInvTypes.includes(t.name)))
  }, [reqInvTypes, listInventoryItems, listProcurementItems, listInventoryTypes])

  return (
    <InventoryConfigContext.Provider
      value={{
        user_permissions: user_permissions,
        getInventoryTypes: getInventoryTypes,
        inventoryTypes: listInventoryTypes,
        statusInventoryTypes: statusInvtTypes,
        getInventoryItems: getInventoryItems,
        inventoryItems: listInventoryItems,
        statusInventoryItems: statusInvtItems,
        getProcurementItems: getProcurementItems,
        procurementItems: listProcurementItems,
        statusProcurementItems: statusProcItems,
        tempInvTypes: tempInvTypes,
      }}
    >
      {props.children}
    </InventoryConfigContext.Provider>
  )
}

export default withAppSettingsConfig(InventoryConfigProvider)
